import React from "react";
import { KButton, KIcon, KMenuDropDown } from "@kyburz/kdesign-system";
import { useStyles } from "./styles";

interface Props {
  loading: boolean;
  isAllSelected: boolean;
  selectedCount: number;
  totalLoaded: number;
  isDownloading: boolean;
  buttonDisabled: boolean;
  fwLoading: boolean;
  onReload: () => void;
  onExport: () => void;
  onScheduleFWUpdate: () => void;
  onFWUpdate: () => void;
  onScheduleConfigUpdate: () => void;
  onConfigUpdate: () => void;
  onBulkUpdate: () => void;
  onSMSCommand: () => void;
  onNewDevice: () => void;
  onImportCSV: () => void;
  onRequestFW: () => void;
  onDownloadConfig: () => void;
  onCancelConfig: () => void;
  onCancelFW: () => void;
  onCancelFsm: () => void;
  onResetFsm: () => void;
  onBulkDelete: () => void;
}


const DevicesToolbar: React.FC<Props> = ({
  loading,
  isAllSelected,
  selectedCount,
  totalLoaded,
  isDownloading,
  buttonDisabled,
  fwLoading,
  onReload,
  onExport,
  onScheduleFWUpdate,
  onFWUpdate,
  onScheduleConfigUpdate,
  onConfigUpdate,
  onBulkUpdate,
  onSMSCommand,
  onNewDevice,
  onImportCSV,
  onRequestFW,
  onDownloadConfig,
  onCancelConfig,
  onCancelFW,
  onCancelFsm,
  onResetFsm,
  onBulkDelete,
}) => {
  const classes = useStyles();

  const statusText = loading
    ? "Loading Devices..."
    : isAllSelected
    ? "All devices selected"
    : `Selected ${selectedCount} / ${totalLoaded} loaded devices`;

  return (
    <div className={classes.ctaContainer}>
      <p className={classes.loadedText}>{statusText}</p>
      <div className={classes.buttonsContainer}>
        <KButton theme="primary" className={classes.button} onClick={onReload}>
          Reload Devices
        </KButton>
        <KButton
          theme="primary"
          className={classes.button}
          icon={<KIcon icon="download" />}
          onClick={onExport}
          disabled={!selectedCount || isDownloading}
        >
          {`Export ${selectedCount >= 100 ? "All" : selectedCount} XLS`}
        </KButton>
        <KButton
          theme="primary"
          className={classes.button}
          icon={<KIcon icon="refresh-cw" />}
          onClick={onScheduleFWUpdate}
          disabled={buttonDisabled}
        >
          Schedule a FW Update
        </KButton>
        <KButton
          theme="primary"
          className={classes.button}
          icon={<KIcon icon="refresh-cw" />}
          onClick={onFWUpdate}
          disabled={buttonDisabled}
        >
          FW Update
        </KButton>
        <KButton
          theme="primary"
          className={classes.button}
          icon={<KIcon icon="refresh-cw" />}
          onClick={onScheduleConfigUpdate}
          disabled={buttonDisabled}
        >
          Schedule a Config Update
        </KButton>
        <KButton
          theme="primary"
          className={classes.button}
          icon={<KIcon icon="refresh-cw" />}
          onClick={onConfigUpdate}
          disabled={buttonDisabled}
        >
          Config Update
        </KButton>
        <KButton
          theme="primary"
          className={classes.button}
          icon={<KIcon icon="sliders" />}
          onClick={onBulkUpdate}
          disabled={buttonDisabled}
        >
          Bulk Update
        </KButton>
        <div>
          <KMenuDropDown
            menuItems={[
              { icon: "plus", title: "New Device", action: onNewDevice },
              { icon: "terminal", title: "SMS Command", action: onSMSCommand, disabled: buttonDisabled },
              { icon: "upload", title: "Import CSV", action: onImportCSV },
              { icon: fwLoading ? "" : "repeat", title: "Request FW", action: onRequestFW, disabled: buttonDisabled || fwLoading },
              { icon: "download", title: "Download Config", action: onDownloadConfig, disabled: buttonDisabled },
              { icon: "x", title: "Cancel Config", action: onCancelConfig, disabled: buttonDisabled },
              { icon: "x", title: "Cancel FW", action: onCancelFW, disabled: buttonDisabled },
              { icon: "x-circle", title: "Cancel Fsm", action: onCancelFsm, disabled: buttonDisabled },
              { icon: "x-square", title: "Reset Fsm", action: onResetFsm, disabled: buttonDisabled },
              { icon: "trash", title: "Bulk delete", action: onBulkDelete, disabled: !selectedCount },
            ]}
          />
        </div>
      </div>
    </div>
  );
};

export default DevicesToolbar;